import { useRef } from 'react';

const CAT_GIFS = [
  "https://media.giphy.com/media/JIX9t2j0ZTN9S/giphy.gif",
  "https://media.giphy.com/media/vFKqnCdLPNOKc/giphy.gif",
  "https://media.giphy.com/media/mlvseq9yvZhba/giphy.gif",
  "https://media.giphy.com/media/pFwRzOLfuGHok/giphy.gif",
  "https://media.giphy.com/media/10dU7AN7xsi1I4/giphy.gif",
  "https://media.giphy.com/media/nR4L10XlJcSeQ/giphy.gif",
  "https://media.giphy.com/media/3oriO0OEd9QIDdllqo/giphy.gif",
  "https://media.giphy.com/media/ule4vhcY1xEKQ/giphy.gif",
  "https://media.giphy.com/media/GeimqsH0TLDt4tScGw/giphy.gif",
  "https://media.giphy.com/media/BzyTuYCmvSORqs1ABM/giphy.gif",
  "https://media.giphy.com/media/pY8jLmZw0ElqvVeRH4/giphy.gif",
  "https://media.giphy.com/media/yWku98eNsMSZOEEWnC/giphy.gif",
  "https://media.giphy.com/media/lh6EKzQdQghw784jvq/giphy.gif",
  "https://media.giphy.com/media/BK1EfIsdkKZMY/giphy.gif",
  "https://media.giphy.com/media/weIRemP4BI4U98HeGX/giphy.gif",
  "https://media.giphy.com/media/12HZukMBlutpoQ/giphy.gif",
  "https://media.giphy.com/media/EFnV02XHwNeIX65Gc7/giphy.gif",
  "https://media.giphy.com/media/9n0CvokbUMaWhFuCkp/giphy.gif",
  "https://media.giphy.com/media/X3ewes5lWn41o6hUjy/giphy.gif",
  "https://media.giphy.com/media/TKa7fQzChHylCQ89to/giphy.gif",
  "https://media.giphy.com/media/v6HmjWFF80ByC2JcRl/giphy.gif",
  "https://media.giphy.com/media/In0Lpu4FVivjISX9HT/giphy.gif",
  "https://media.giphy.com/media/2g6sCTsSoVuSfSxK4W/giphy.gif",
  "https://media.giphy.com/media/cbm0J4DEIqKHsKxYHA/giphy.gif",
];

function getRandomGif() {
  const key = 'cat_gif_weights_global';
  let weights = JSON.parse(localStorage.getItem(key) || 'null');
  if (!weights || weights.length !== CAT_GIFS.length) weights = CAT_GIFS.map(() => 10);
  const total = weights.reduce((s,w) => s+w, 0);
  let rand = Math.random() * total;
  let chosen = 0;
  for (let i = 0; i < weights.length; i++) { rand -= weights[i]; if (rand <= 0) { chosen = i; break; } }
  weights = weights.map((w, i) => i === chosen ? Math.max(1, w-4) : Math.min(10, w+1));
  localStorage.setItem(key, JSON.stringify(weights));
  return CAT_GIFS[chosen];
}

export default function CatLoader({ loading }) {
  const gifRef = useRef(getRandomGif());
  if (!loading) return null;
  return (
    <div style={{position:'fixed',inset:0,zIndex:200,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',background:'rgba(10,15,26,0.88)',backdropFilter:'blur(10px)'}}>
      <img src={gifRef.current} alt="loading" style={{width:150,height:150,objectFit:'contain',borderRadius:18,marginBottom:18,boxShadow:'0 8px 32px rgba(0,0,0,0.4)'}}/>
      <div style={{fontSize:13,color:'rgba(148,163,184,0.6)',letterSpacing:'2px',textTransform:'uppercase'}}>загружаем данные...</div>
    </div>
  );
}
